(() => {
  const phoneSelector = 'input[name="attributes[Telefono]"]';
  const checkoutSelector = '[data-required-phone-form]';
  let checkoutPending = false;

  function clearGuidance(input) {
    const field = input.closest('.cart__phone-field');
    const guidance = field?.querySelector('[data-phone-guidance]');
    if (guidance) guidance.hidden = true;
    field?.classList.remove('is-required');
    input.removeAttribute('aria-invalid');
    input.setAttribute('aria-describedby', `${input.id}-help`);
  }

  function showGuidance(input, issue = 'missing') {
    const tooLong = issue === 'too-long';
    const saveFailed = issue === 'save';
    const field = input.closest('.cart__phone-field');
    const guidance = field?.querySelector('[data-phone-guidance]');
    if (guidance) {
      guidance.querySelector('[data-phone-guidance-heading]').textContent = saveFailed
        ? 'No pudimos guardar tu WhatsApp'
        : tooLong ? 'Un detalle antes de seguir' : '¡Nos falta tu WhatsApp!';
      guidance.querySelector('[data-phone-guidance-message]').textContent = saveFailed
        ? 'Tu WhatsApp sigue acá. Volvé a intentar para continuar con tu pedido.'
        : tooLong ? 'Usá hasta 30 caracteres para tu WhatsApp y seguimos con el pedido.'
        : 'Completalo acá para que podamos coordinar tu pedido.';
      guidance.hidden = false;
      input.setAttribute('aria-describedby', `${input.id}-help ${guidance.id}`);
    }
    field?.classList.add('is-required');
    if (saveFailed) input.removeAttribute('aria-invalid');
    else input.setAttribute('aria-invalid', 'true');
    input.focus({ preventScroll: true });
    (field || input).scrollIntoView({
      block: 'center',
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  function getPhoneInput(control) {
    const form = document.getElementById(control.dataset.requiredPhoneForm);
    return form?.elements.namedItem('attributes[Telefono]');
  }

  async function continueCheckout(event, control) {
    event.preventDefault();
    if (checkoutPending) return;
    const input = getPhoneInput(control);
    if (!input) return;
    if (!input.value.trim() || input.value.length > 30) {
      showGuidance(input, input.value.length > 30 ? 'too-long' : 'missing');
      return;
    }

    clearGuidance(input);
    checkoutPending = true;
    control.setAttribute('aria-disabled', 'true');
    control.setAttribute('disabled', 'disabled');

    try {
      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: { Telefono: input.value.trim() } }),
      });
      if (!response.ok) throw new Error('Phone could not be saved');
      window.location.assign(control.href || '/checkout');
    } catch (error) {
      checkoutPending = false;
      control.removeAttribute('aria-disabled');
      control.removeAttribute('disabled');
      showGuidance(input, 'save');
      console.error(error);
    }
  }

  document.addEventListener('input', (event) => {
    if (!event.target.matches(phoneSelector)) return;
    document.querySelectorAll(phoneSelector).forEach((input) => {
      if (input !== event.target) input.value = event.target.value;
      clearGuidance(input);
    });
  });

  document.addEventListener('click', (event) => {
    const control = event.target.closest(checkoutSelector);
    if (control) continueCheckout(event, control);
  });

  document.addEventListener('submit', (event) => {
    const control = event.submitter;
    if (control?.matches(checkoutSelector)) continueCheckout(event, control);
  });

  document.addEventListener('invalid', (event) => {
    if (!event.target.matches(phoneSelector)) return;
    event.preventDefault();
    showGuidance(event.target, event.target.value.length > 30 ? 'too-long' : 'missing');
  }, true);
})();
